// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Theme } from '@mui/material/styles';
import { sectionHeaderStyles } from '../BulkDownloadRow/styles';

const styles = (theme: Theme) => ({
  ...sectionHeaderStyles(theme),
  titleButton: {
    flexShrink: 0,
    borderRadius: `${theme.shape.borderRadius}px`,
  },
  arrowButton: {
    flexShrink: 0,
  },
});

export default styles;
